import { render } from "./ClassDiaryCreate.vue?vue&type=template&id=56dbd74a&scoped=true&ts=true"
import script from "./ClassDiaryCreate.vue?vue&type=script&lang=ts"
export * from "./ClassDiaryCreate.vue?vue&type=script&lang=ts"

import "./ClassDiaryCreate.vue?vue&type=style&index=0&id=56dbd74a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dbd74a"]])

export default __exports__